import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { asyncLogout, redirectTo } from 'actions/auth';

export class UserInfo extends Component {
  static propTypes = {
    auth: PropTypes.object,
    user: PropTypes.object,
    onLogout: PropTypes.func.isRequired
  };

  prepareForLogin = () => {
    const { location, saveRedirectTo } = this.props;
    if (location.path !== '/login') {
      saveRedirectTo(location.pathname + location.search);
    }
  };

  render() {
    const { auth, user, onLogout } = this.props;

    if (auth.isAuthenticated) {
      return (
        <li className="nav-item userInfo d-flex align-items-center">
          <span className="d-none d-lg-inline">Welcome back,&nbsp;</span>
          <div className="dropdown">
            <div className="nav-link dropdown-toggle">{user.name}</div>
            <div className="dropdown-menu">
              <Link to="/my-purchases/image-bundles" className="dropdown-item">
                My Purchases
              </Link>
              <Link
                to="/logout"
                className="dropdown-item"
                onClick={event => {
                  event.preventDefault();
                  onLogout();
                }}
              >
                Logout
              </Link>
            </div>
          </div>
        </li>
      );
    } else {
      return (
        <li className="nav-item">
          <Link to="/login" className="btn btn-green" onClick={this.prepareForLogin}>
            Login
          </Link>
        </li>
      );
    }
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user
});

const mapDispatchToProps = dispatch => ({
  onLogout: () => dispatch(asyncLogout()),
  saveRedirectTo: path => dispatch(redirectTo(path))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserInfo));
